export default [
  {
    title: 'admin',
    email: 'admin-demo@bug.com',
    password: 'anypass'
  },
  {
    title: 'tester',
    email: 'tester-demo@bug.com',
    password: 'anypass'
  },
  {
    title: 'projectManager',
    email: 'projectManager-demo@bug.com',
    password: 'anypass'
  },
  {
    title: 'developer',
    email: 'developer-demo@bug.com',
    password: 'anypass'
  }
];
